import React from 'react';
import styles from './CustomPopup.module.css';

const CustomPopup = ({ message, show, handleClose }) => {
  return (
    <div className={`${styles.popupWrapper} ${show ? styles.show : ''}`}>
      <div className={styles.popupContent}>
        <h3>{message}</h3>
        <button className={styles.popUpBtn} onClick={handleClose}>OK</button>
      </div>
    </div>
  );
};

export default CustomPopup;
